module.exports = __webpack_public_path__ + "media/bootstrap-icons/credit-card-2-back-461ad3bb.svg";